import ReferencesUser from 'features/references/referencesUser';
import { useTitle } from '../helpers';

/**
 * @page References user page
 */
const ReferencesUserPage = () => {
  useTitle('Информация о справке');

  return (
    <div>
      <h3>Страница информации о справке</h3>
      <ReferencesUser />
    </div>
  );
};

export default ReferencesUserPage;
